export const AUTH_SSO_CLIENT_ID_QUERY = 'client_id';
export const AUTH_SSO_REDIRECT_URL_QUERY = 'redirect_url';
export const AUTH_SSO_SCOPE_QUERY = 'scope';
